/* unplugin-vue-components disabled */import { render } from "./BaseLayout.vue?vue&type=template&id=59842ece&scoped=true&ts=true"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=59842ece&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59842ece"]])

export default __exports__